import React, { useEffect, useState } from 'react';
import { CircularProgress, Container } from '@mui/material';
import Login from './Login';
import {API_URL} from "./lib/utils";

const AuthWrapper = ({ children }) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${API_URL}/auth/status`, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log({data});
                setAuthenticated(data.authenticated);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching authentication status:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <CircularProgress />
            </Container>
        );
    }

    return authenticated ? children : <Login />;
};

export default AuthWrapper;
